import { Image, UIHeading2, UIText2 } from '@cian/ui-kit';

import { type FC } from 'react';

import blankCardsImg from './blankCardsImg.png';

import styles from './ListingNoCards.css';

export const ListingNoCards: FC = () => {
  return (
    <div className={styles['container']} data-testid="listing.no-cards">
      <Image alt="Нет объявлений" height={80} src={blankCardsImg} width={80} />
      <div className={styles['heading-wrapper']}>
        <UIHeading2 as="h2">У нас ещё нет таких объектов</UIHeading2>
      </div>
      <UIText2>Попробуйте изменить фильтры</UIText2>
    </div>
  );
};
